﻿import React from 'react';
import { Content_Container_Props } from '@Util/Types';

export default function Content_Container(props: Content_Container_Props): JSX.Element {
    return (
        <div className="Content_Container">
            {props.children}
        </div>
    );
}